<template>
  <v-dialog v-model="feedbackdialog" class="Kanit" max-width="500" persistent max-height="500px" style="overflow-y: hidden; border-radius: 20px !important;">
    <v-card tile>
      <v-toolbar card style="background: #1b232d !important;">
        <v-toolbar-title class="Kanit" style="color: white;">
          <v-icon color="white" style="font-size: 25px;">feedback</v-icon> ข้อเสนอแนะ
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card color="grey lighten-4" flat>
      <v-card-text>
        <v-flex xs12 sm12 md12 xl12 style="justify-content: center;display: flex;">
          <v-icon color="black" style="font-size: 60px !important;">feedback</v-icon>
        </v-flex>
        <h1 style="font-size: 24px;display: flex;justify-content: center;" class="Kanit"><b>ข้อเสนอแนะ</b></h1>
        <div>
          <p style="font-size: 14px;color: black;" class="Kanit"><b>เราดีใจที่ได้ยินว่าคุณคิดอย่างไรกับเรา ความคิดเห็นจากคุณจะช่วยปรับปรุงประสบการณ์การใช้งาน One Chat ได้ดียิ่งขึ้น</b></p>
        </div>
        <div>
          <p style="font-size: 14px;color: black;" class="Kanit">คุณสามารถแชร์ประสบการณ์การใช้งาน เสนอแนะบริการ หรือแจ้งความผิดพลาดได้ที่นี่ หากต้องการความช่วยเหลือโปรดติดต่อ 02-257-7269 หรือ <a @click="helpcenterDialog = true">ศูนย์ช่วยเหลือ</a></p>
        </div>
        <v-container fluid>
          <v-layout row>
            <v-flex xs12>
              <v-textarea outline name="input-1" placeholder="ข้อเสนอแนะ" v-model="comment" style="color: black;font-size: 18px; resize: none !important;" class="Kanit"></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" :disabled="comment == ''" class="btnsendfeed Kanit" @click="sendfeedback()">ส่งข้อเสนอแนะ</v-btn>
      </v-card-actions>
    </v-card>
    <HelpcenterDialog :helpcenterDialog="helpcenterDialog" @closeHelpcenter="closeHelpcenter"></HelpcenterDialog>
  </v-dialog>
</template>
<script type="text/javascript">
import HelpcenterDialog from '@/components/managebot/dialogNavbar/helpcenterDialog'
export default {
  props: { 'feedbackdialog': false },
  data: () => ({
    token: '',
    comment: '',
    status: '',
    helpcenterDialog: false,
    content: '&nbsp;&nbsp;&nbsp;บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) 1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12 และชั้น IT ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310 <br>โทรศัพท์: 02-257-7269 อีเมล: one-platform@inet.co.th'
  }),
  components: {
    HelpcenterDialog
  },
  created() {
    this.token = localStorage.getItem('tokenuser')
  },
  methods: {
    closeDialog() {
      this.$emit('closeHelp', false)
      this.comment = ''
    },
    closeHelpcenter() {
      this.helpcenterDialog = false
    },
    sendfeedback() {
      if (this.comment === '') {
        this.$swal({
          title: 'ข้อเสนอแนะ',
          text: 'กรุณากรอกข้อเสนอแนะ!',
          type: 'warning',
          showCloseButton: true,
          reverseButtons: true
        })
      } else {
        this.$http.post(process.env.APImanage + '/feedback', { tokenuser: this.token, comment: this.comment }).then((response) => {
          this.status = response.body['status']
          if (this.status === 'success') {
            this.$swal({
              title: 'ส่งข้อเสนอแนะ',
              text: 'ส่งข้อเสนอแนะสำเร็จ',
              type: 'success',
              showCloseButton: true,
              reverseButtons: true
            })
            this.comment = ''
            this.$emit('closeHelp', false)
          }
        })
      }
    }
  }
}

</script>
<style type="text/css" scoped>
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

.btnsendfeed {
  width: 100%;
  color: black;
  border-radius: 5px;
}
textarea { resize: none; }
/*.application .theme--light.input-group input, .application .theme--light.input-group textarea, .theme--light .input-group input, .theme--light .input-group textarea {
  color: rgba(0,0,0,.87) !important;
}*/

</style>



// WEBPACK FOOTER //
// src/components/managebot/dialogNavbar/feedbackDialog.vue